<table mat-table #genericTable="matSort" [dataSource]="table_dataSource"  matSortDirection="desc" matSort (matSortChange)="customSort($event)" aria-describedby="table">
  <ng-container *ngFor="let column of table_Columns" [matColumnDef]="column.columnDef">
    <th scope="col" mat-header-cell class="headerborder" *matHeaderCellDef mat-sort-header [style.background-color]="sort?.active==column.columnDef?'#F0F5FF':null" [disabled]="column.sortHeader=='no'?true:false">{{ column.header }}</th>
    <td mat-cell *matCellDef="let row" [style.background-color]="sort?.active==column.columnDef?'#F0F5FF':null" [innerHTML]="column.cell(row)|safeHTML" (click)="onRowCellClick(row,column.columnDef,$event)"></td>
  </ng-container>

  <!-- Header row second group -->
  <ng-container matColumnDef="header-row-OP">
    <th id="opColumn" mat-header-cell *matHeaderCellDef [attr.colspan]="OPColumn"><span class="headerColor">OP Reference</span></th>
  </ng-container>

  <ng-container matColumnDef="header-row-Cod">
    <th id="codColumn" mat-header-cell *matHeaderCellDef [attr.colspan]="CodColumn"><span class="headerColor">Cod Reference/Other Status</span></th>
  </ng-container>

  <ng-container matColumnDef="header-row-CIG" *ngIf="!hideSTTCIG">
    <th id="cigColumn" mat-header-cell *matHeaderCellDef [attr.colspan]="CIGColumn"><span class="headerColor">CIG Reference/Other Status</span></th>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="matHeaderRowDefs"></tr>
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
<div #genericTablePaginator="" *ngIf="data_length === 0" class="align-items-center text-align-norecords">{{noRecords}}</div>
